import { ItemSortOption } from '@rematter/frontend-lib-api-client';

import { ObjectRefRecord } from '~/shared/components/custom-attributes/types';
import { createQueryHook } from '~/shared/providers/api';

export const useInventoryItemsQuery = createQueryHook(
  'inventory.items',
  (params: {
    searchTerm?: string;
    sorting?: ItemSortOption[];
    limit?: number;
    offset?: number;
  }) => ({
    items: {
      __args: {
        filter: params.searchTerm
          ? {
              searchTerm: params.searchTerm,
            }
          : undefined,
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 10,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
      },
    },
  }),
  {
    select: (data): ObjectRefRecord[] =>
      data?.items.entries.map((item) => ({
        id: item.id,
        name: item.name,
      })) ?? [],
  },
);
